/**
 * Shared chart styling so every cheat-sheet chart uses the same design tokens.
 * Colors are the project's HSL CSS variables (see src/index.css) wrapped in
 * hsl(var(--token)), matching the convention in MrrGrowthCalculator.tsx.
 */

export const ACCENT = "hsl(var(--accent))"; // green — gains / positive
export const ACCENT_SOFT = "hsl(var(--accent) / 0.55)";
export const DESTRUCTIVE = "hsl(var(--destructive))"; // red — losses / negative
export const DESTRUCTIVE_SOFT = "hsl(var(--destructive) / 0.6)";

/**
 * Product chart colors, mirrored verbatim from the app so library metric charts
 * match what users see in Bigdelta (POSITIVE_NEGATIVE color mode). Source:
 * monorepo packages/app/src/shared/properties/const.ts. Intentionally fixed
 * hexes (not theme variables) to stay identical to the product in either theme.
 */
export const CHART_POSITIVE = "#64b4a4"; // new (gain, base positive)
export const CHART_POSITIVE_MUTED = "#82bfb3"; // expansion
export const CHART_POSITIVE_SEMI_MUTED = "#a2cdc4"; // reactivation
export const CHART_NEGATIVE = "#c76b73"; // churn (loss, base negative)
export const CHART_NEGATIVE_MUTED = "#eeddde"; // contraction
export const FOREGROUND = "hsl(var(--foreground))";
export const MUTED = "hsl(var(--muted-foreground) / 0.45)"; // neutral bars
export const MUTED_FG = "hsl(var(--muted-foreground))"; // axis ticks / labels
export const BORDER = "hsl(var(--border))"; // gridlines / axes

/** Tooltip surface styling shared across charts. */
export const tooltipStyle = {
  background: "hsl(var(--popover))",
  border: "1px solid hsl(var(--border))",
  borderRadius: "0.5rem",
  color: "hsl(var(--popover-foreground))",
  fontSize: "0.8rem",
} as const;

/** Common axis props (keeps each chart file lean). */
export const xAxisProps = {
  stroke: MUTED_FG,
  fontSize: 12,
  tickLine: false,
  axisLine: { stroke: BORDER },
} as const;

export const yAxisProps = {
  stroke: MUTED_FG,
  fontSize: 12,
  tickLine: false,
  axisLine: false,
} as const;
